import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';
import { Lock, Sparkles, Check, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const BENEFITS = [
  'Inventario de IA y fichas de cada herramienta',
  'Gestión de Riesgos con controles y seguimiento',
  'Centro de Excelencia de IA (roles, políticas y procesos)',
  'Gestión del Cambio y medición de adopción',
  'Auditoría de conversaciones de IA',
  'Usuarios ilimitados para tu equipo',
];

export function UpgradePlanScreen() {
  const navigate = useNavigate();

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <Card className="border-2 border-primary/20 bg-gradient-to-br from-primary/5 to-secondary/5">
        <CardContent className="pt-8 pb-8 space-y-6 text-center">
          <div className="w-14 h-14 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto">
            <Lock className="w-7 h-7 text-primary" />
          </div>
          <div className="space-y-2">
            <h1 className="text-2xl font-bold text-foreground">
              Este módulo está en el plan empresarial
            </h1>
            <p className="text-muted-foreground">
              Tu empresa está en el plan gratuito. Mejora de plan para desbloquear todos los módulos de
              gestión y gobierno de IA.
            </p>
          </div>

          <ul className="space-y-2 text-left max-w-md mx-auto">
            {BENEFITS.map((b) => (
              <li key={b} className="flex items-start gap-2 text-sm text-muted-foreground">
                <Check className="w-4 h-4 text-primary mt-0.5 shrink-0" />
                <span>{b}</span>
              </li>
            ))}
          </ul>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button variant="outline" className="gap-2" onClick={() => navigate('/dashboard')}>
              <ArrowLeft className="w-4 h-4" />
              Volver al inicio
            </Button>
            <Button className="gap-2" onClick={() => navigate('/empresas')}>
              <Sparkles className="w-4 h-4" />
              Quiero mejorar de plan
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export default UpgradePlanScreen;
